<div>
  <div class="card p-5">
    <div class="w-full mb-5">
      <div class="">
        <p-panel
          [header]="'MANAGE_USERS.FILTER_HEADER' | translate"
          [toggleable]="true"
          expandIcon="fa-solid fa-chevron-up"
          collapseIcon="fa-solid fa-chevron-down"
        >
          <div class="mt-5">
            <input
              type="text"
              pInputText
              [placeholder]="'MANAGE_USERS.SEARCH_BY_EMAIL' | translate"
              [(ngModel)]="filterValue"
              (input)="filterByEmail()"
              class="form-control mb-2"
            />
          </div>
        </p-panel>
        <div class="card-body mt-3">
        <div class="flex items-center">
          <div class="ml-auto">
            <button
              pButton
              [size]="'large'"
              [severity]="'success'"
              routerLink="../create-user"
            >
              {{ "MANAGE_USERS.CREATE_USER" | translate }}
            </button>
          </div>
        </div>
        </div>
      </div>
    </div>
    <ngx-datatable
      #myTable
      class="bootstrap w-full"
      [rows]="filteredRows"
      [columns]="columns"
      [columnMode]="ColumnMode.force"
      [headerHeight]="60"
      [footerHeight]="80"
      [summaryRow]="false"
      [summaryPosition]="'top'"
      [limit]="40"
      [rowHeight]="60"
      [reorderable]="false"
      [scrollbarH]="shouldEnableHorizontalScroll()"
      (page)="onPage($event)"
    >
      <ngx-datatable-row-detail
        [rowHeight]="230"
        #myDetailRow
        (toggle)="onDetailToggle($event)"
        [@datatableAnimation]="expanded ? 'expanded' : 'collapsed'"
      >
        <ng-template
          let-row="row"
          let-expanded="expanded"
          ngx-datatable-row-detail-template
        >
          @if(expanded){
          <div class="detail-row-container">
            <!-- Detail Row Columns -->
            <div class="detail-row-grid">
              <!-- Left Column -->
              <div class="detail-row-column">
                @for(col of columns;track col){ @if(['role', 'firstName',
                'lastName'].includes(col.prop)){
                <div class="detail-row-item">
                  <strong class="detail-row-label">{{ col.name | translate }}:</strong>
                  <span class="detail-row-value">{{ row[col.prop] }}</span>
                </div>
                } }
              </div>

              <!-- Right Column -->
              <div class="detail-row-column">
                @for(col of columns;track col){ @if(['createdDate',
                'updatedDate'].includes(col.prop)){
                <div class="detail-row-item">
                  <strong class="detail-row-label">{{ col.name | translate }}:</strong>
                  <span class="detail-row-value">{{ row[col.prop] }}</span>
                </div>
                }}
              </div>
            </div>

            <!-- Detail Row Footer with Buttons -->
            <div class="row mt-5">
              <div class="col">
                <button
                  pButton
                  [severity]="'warn'"
                  [size]="'large'"
                  class="!px-5"
                  [routerLink]="['/user-details/', row.userId]"
                >
                  {{"MANAGE_USERS.USER_DETAILS" | translate}}
                </button>
              </div>
            </div>
          </div>
          }
        </ng-template>
      </ngx-datatable-row-detail>
      <ngx-datatable-column
        [width]="50"
        [resizeable]="false"
        [sortable]="false"
        [draggable]="false"
        [canAutoResize]="false"
      >
        <ng-template
          let-row="row"
          let-expanded="expanded"
          ngx-datatable-cell-template
        >
          <a
            href="javascript:void(0)"
            class="expand-collapse-icon ps-3 !text-base !text-gray-500"
            title="Expand/Collapse Row"
            (click)="toggleExpandRow(row)"
          >
            <i
              [class]="expanded ? 'fa fa-chevron-down' : 'fa fa-chevron-right'"
            ></i>
          </a>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        [name]="'MANAGE_USERS.USER_ID' | translate"
        prop="userId"
        [width]="getColumnWidth('userId')"
        [resizeable]="true"
      >
        <ng-template let-row="row" ngx-datatable-cell-template>
          <div class="case-code-class">{{ row.userId }}</div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        [name]="'MANAGE_USERS.USERNAME' | translate"
        prop="username"
        [width]="getColumnWidth('username')"
        [resizeable]="true"
      >
        <ng-template let-row="row" ngx-datatable-cell-template>
          <div class="case-date-class">{{ row.username }}</div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        [name]="'MANAGE_USERS.EMAIL' | translate"
        prop="email"
        [width]="getColumnWidth('email')"
        [resizeable]="true"
      >
        <ng-template let-row="row" ngx-datatable-cell-template>
          <div class="case-date-class">{{ row.email }}</div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        [name]="'MANAGE_USERS.FIRST_NAME' | translate"
        prop="firstName"
        [width]="getColumnWidth('firstName')"
        [resizeable]="true"
      >
        <ng-template let-row="row" ngx-datatable-cell-template>
          <div class="case-date-class">{{ row.firstName }}</div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        [name]="'MANAGE_USERS.LAST_NAME' | translate"
        prop="lastName"
        [width]="getColumnWidth('lastName')"
        [resizeable]="true"
      >
        <ng-template let-row="row" ngx-datatable-cell-template>
          <div class="case-date-class">{{ row.lastName }}</div>
        </ng-template>
      </ngx-datatable-column>
    </ngx-datatable>
  </div>
</div>
